import { LinearProgress, linearProgressClasses, styled } from "@mui/material";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useProgress } from "src/context/ProgressContext";
import { useIsMobile } from "src/hooks/useIsMobile";

const BorderLinearProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile?: boolean }>(({ isMobile }) => ({
  height: isMobile ? 9 : 12,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#CCF6F7",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#00B6B9",
  },
}));

const NO_PROGRESSBAR_PATHS = [
  "shipping-information",
  "identity-verification-1",
  "identity-verification-2",
  "identity-verification-3",
  "payment-information",
  "payment-confirmation",
  "welcome",
  "result-information",
  "ec",
];

const ProgressBar = () => {
  const { progressPercentage } = useProgress();
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  const hasNoProgressBar = useMemo(
    () => NO_PROGRESSBAR_PATHS.some((p) => pathname.includes(p)),
    [pathname]
  );

  if (hasNoProgressBar === true) {
    return null;
  }

  return (
    <BorderLinearProgress
      variant="determinate"
      value={progressPercentage}
      isMobile={isMobile}
    />
  );
};

export default ProgressBar;
